import { render, staticRenderFns } from "./ChartWaterHistory.vue?vue&type=template&id=536c880b&"
import script from "./ChartWaterHistory.vue?vue&type=script&lang=js&"
export * from "./ChartWaterHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChartWaterHistory.vue?vue&type=style&index=0&id=536c880b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports